import { defineStore, acceptHMRUpdate } from 'pinia'
import type { GroupSchedule } from '@/api/groups'

export interface EditGroupData {
  // Pre-filled values when opening the group form for editing.

  name: string | null
  // Display name.

  description: string | null
  // Optional description; null when absent.

  start: string
  // "YYYY-MM-DD".

  end: string | null
  // "YYYY-MM-DD"; null while still active.

  hasDedicatedSchedule: boolean
  // Immutable after creation — shown read-only in the edit form.

  bookingTypeId: string | null
  // Immutable after creation — shown read-only (resolved to a name/address) in the edit form.

  businessServiceTypeId: string | null
  // Currently assigned service type; null when not set.

  performerIds: string[]
  // Currently assigned performer ids, pre-selecting the performer picker.

  schedule: GroupSchedule[]
  // Existing slots, with their ids, so the schedule editor can reconcile
  // edits/removals against the dedicated create/update/delete endpoints
  // instead of re-creating everything from scratch.
}

export const useAddGroupFormStore = defineStore('addGroupForm', {
  state: () => ({
    isOpen: false,
    editId: null as string | null,
    editData: null as EditGroupData | null,
  }),
  actions: {
    open(): void {
      this.isOpen = true
      this.editId = null
      this.editData = null
    },
    openForEdit(id: string, data: EditGroupData): void {
      this.isOpen = true
      this.editId = id
      this.editData = data
    },
    close(): void {
      this.isOpen = false
      this.editId = null
      this.editData = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAddGroupFormStore, import.meta.hot))
}
